var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFeaturedSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70588 31.1265C5.27515 31.6166 4.53664 31.685 4.02325 31.2823C3.46762 30.8465 3.39232 30.0334 3.85849 29.5029L15.7257 16L3.85849 2.49706C3.39232 1.96664 3.46762 1.15347 4.02325 0.717658C4.53665 0.314982 5.27515 0.383364 5.70588 0.87346L19 16L5.70588 31.1265Z",
    fill: "#777081"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 16,
    r: 3,
    fill: "#FBD207"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFeaturedSlider);
export default __webpack_public_path__ + "static/media/arrow_featured_slider.84516c65.svg";
export { ForwardRef as ReactComponent };